import React, { useEffect, useState } from "react";
import MaintenanceScreen from "./MaintenanceScreen";

// Config shape (three-state activation):
//   masterEnabled = false            -> off always (escape hatch)
//   masterEnabled = true + window    -> on only inside [startsAt, endsAt]
//   masterEnabled = true + no window -> on immediately (emergency)
const FLAG_URL = `${process.env.PUBLIC_URL || ""}/maintenance.json`;

// Start the fetch as soon as this module loads (in parallel with Auth0),
// so the gate rarely has to wait by the time it first renders.
let cachedCfg = undefined;
const maintenanceConfigPromise = fetch(`${FLAG_URL}?t=${Date.now()}`, {
  cache: "no-store",
})
  .then((res) => res.json())
  .then((data) => (data && typeof data === "object" ? data : null))
  .catch(() => null)
  .then((data) => {
    cachedCfg = data;
    return data;
  });

function computeIsDown(cfg) {
  if (!cfg || !cfg.masterEnabled) return false;
  const now = Date.now();
  const starts = cfg.startsAt ? new Date(cfg.startsAt).getTime() : null;
  const ends = cfg.endsAt ? new Date(cfg.endsAt).getTime() : null;
  if (starts && now < starts) return false;
  if (ends && now > ends) return false;
  return true;
}

function MaintenanceGate({ children }) {
  const [cfg, setCfg] = useState(() =>
    cachedCfg === undefined ? null : cachedCfg
  );

  useEffect(() => {
    if (cachedCfg !== undefined) {
      setCfg(cachedCfg);
      return;
    }
    let cancelled = false;
    maintenanceConfigPromise.then((data) => {
      if (!cancelled) setCfg(data);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (computeIsDown(cfg)) {
    return (
      <MaintenanceScreen
        title={cfg?.title}
        message={cfg?.message}
        startsAt={cfg?.startsAt}
        endsAt={cfg?.endsAt}
        contactEmail={cfg?.contactEmail}
      />
    );
  }

  return children;
}

export default MaintenanceGate;
